var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "marquee-gallery-wrapper" }, [
    !_vm.isDevice()
      ? _c("div", { ref: "cursor-follower", staticClass: "cursor-follower" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.cursor.active,
                  expression: "cursor.active",
                },
              ],
              staticClass: "cursor",
              class: [_vm.cursor.position],
            },
            [_c("span", [_vm._v("x")]), _vm._v(_vm._s(_vm.cursor.text))]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "marquee6k marquee-gallery",
        attrs: { "data-speed": "0.5" },
      },
      [
        _c(
          "div",
          _vm._l(_vm.photos, function (photo, index) {
            return _c("img", {
              staticClass: "img",
              attrs: { src: photo.src },
              on: { load: _vm.onImageLoad },
            })
          }),
          0
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "navigation-button-prev",
        attrs: { type: "button" },
        on: {
          click: function ($event) {
            return _vm.toggleSpeed(-1)
          },
        },
      },
      [_c("i", { staticClass: "icon-arrow-slim-left" })]
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "navigation-button-next",
        attrs: { type: "button" },
        on: {
          click: function ($event) {
            return _vm.toggleSpeed(1)
          },
        },
      },
      [_c("i", { staticClass: "icon-arrow-slim-right" })]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }